import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import PanelSchedule from '~/panels/components/PanelSchedule/PanelSchedule'
import PanelSessionsLog from '~/panels/components/PanelSessionsLog/PanelSessionsLog'
import SessionItem from '~/components/Session/Session'
import StudentSessionRating from '~/panels/components/StudentSessionRating/StudentSessionRating'
import { formatAsDay, getFirstDateOfMonth } from '~/utils/time'
import { useGetProfileQuery, useGetStudentExistsQuery } from '~/redux/apis/student-api'
import { useGetSessionsListQuery } from '~/redux/apis/session-api'
import { useAppSelector } from '~/redux/hooks'
import { isAuthenticated } from '~/auth/slices/auth.slice'

export default function StudentAppointments(): React.ReactElement {
  const { t } = useTranslation('studentPanel')
  const [date, setDate] = useState(new Date())
  const authenticated = useAppSelector(isAuthenticated)
  const { data: isStudentExists } = useGetStudentExistsQuery(undefined, { skip: !authenticated })
  const { data: student } = useGetProfileQuery(undefined, { skip: !isStudentExists })
  const { data: sessionsList } = useGetSessionsListQuery({
    page: 0,
    range: 20,
    from: formatAsDay(getFirstDateOfMonth(date)),
  })

  const nextSession = student?.nextSession

  return (
    <section className="max-w-3xl md:-mx-4 lg:mx-0">
      <div className="space-y-4 md:space-y-0 md:space-x-4 md:space-x-reverse flex flex-col md:flex-row-reverse md:justify-end">
        <div className="md:flex-1 max-w-sm space-y-4 flex flex-col">
          {nextSession && (
            <div>
              <span className="block mb-1 font-bold text-hotpink">{t('nextAppointment')}</span>
              <SessionItem forceExpanded session={nextSession} sessionTutor={nextSession.sessionMentor} />
            </div>
          )}
          <StudentSessionRating />
          <PanelSessionsLog className="hidden md:block" />
        </div>
        <div className="flex justify-center">
          <PanelSchedule appointments={sessionsList} date={date} onDateClick={(d) => setDate(d)} />
        </div>
        <hr className="md:hidden border-t border-gray-light" />
        <PanelSessionsLog className="md:hidden" />
      </div>
    </section>
  )
}
